var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-element-loading',{attrs:{"active":_vm.storage,"is-full-screen":true,"background-color":"#FFFFFF","color":"#FF6907","spinner":"bar-fade-scale"}},[_c('img',{attrs:{"src":require("../../assets/loading.gif"),"alt":"Loading..."}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }